import { createApp } from 'vue';
import rest_select_page from "./RestSelectPage.vue";

const G_REST_SELECT_PAGE = createApp({
    name: "G_REST_SELECT_PAGE",
    id: "G_REST_SELECT_PAGE",
    components: {
        rest_select_page
    }
});
//G_REST_SELECT_PAGE.mount('#go_rest_select_page');
export default G_REST_SELECT_PAGE;
